import { z } from 'zod';

import {
  GetMewsServicesResponseSchema,
  GetMewsAccountCategoriesResponseSchema,
  GetMewsTaxCodesResponseSchema,
  MewsConfigResponseSchema,
} from './schemas';
import { buildQueryString } from '../../utils/querystring';
import { makeEndpoint } from '../common';
import { integrationUrl, IntegrationType } from '../integration/integration';

export const GetMewsServicesEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ query }) => `v1/mews/services?${buildQueryString(query)}`,
  requestSchema: z.void(),
  querySchema: z.object({
    brandId: z.string(),
  }),
  responseSchema: GetMewsServicesResponseSchema,
});

export const GetMewsAccountCategoriesEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ query }) => `v1/mews/accounting-categories?${buildQueryString(query)}`,
  requestSchema: z.void(),
  querySchema: z.object({
    brandId: z.string(),
  }),
  responseSchema: GetMewsAccountCategoriesResponseSchema,
});

export const GetMewsTaxCodesEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ query }) => `v1/mews/tax-codes?${buildQueryString(query)}`,
  requestSchema: z.void(),
  querySchema: z.object({
    brandId: z.string(),
  }),
  responseSchema: GetMewsTaxCodesResponseSchema,
});

export const GetMewsConfigEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId }: { brandId: string }) => `${integrationUrl({ brandId, integrationType: IntegrationType.MEWS })}/config`,
  responseSchema: MewsConfigResponseSchema,
  requestSchema: z.void(),
});
